<template>
  <b-avatar-group size="35px">
    <b-avatar
      v-for="(item, index) in collaborators"
      :key="index"
      variant="primary"
      :text="item.userInitials"
      :src="item.avatar"
      v-b-popover.hover.top="item.name"
    >
    </b-avatar>
  </b-avatar-group>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    value: {
      type: [Array, String],
      required: true
    }
  },
  data () {
    return {
      collaborators: []
    }
  },
  methods: {
    async loadCollaboratorsInfo () {
      if (!this.value) return
      for (const item of this.value) {
        const res = await commonsApi.axiosGetWrapper(`/users/user-meta/${item}`)
        const userInfo = res.data
        const signer = {
          name: `${userInfo.firstname} ${userInfo.lastname}`,
          userInitials: res.data?.userInitials,
          avatar: userInfo?.profilePicture || ''
        }
        this.collaborators.push(signer)
      }
    }
  },
  async created () {
    try {
      await this.loadCollaboratorsInfo()
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
